import React,{Fragment} from "react";
import {AlignLeftOutlined} from "@ant-design/icons"
import dynamic from "next/dynamic";
const ReactQuill = dynamic(() => import('react-quill'), {
    ssr: false,
    loading: () => <div/>,
})
const fonts=['arial','times','roboto',]

const toolbarOptions = [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': fonts }],
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{ 'color': [] }, { 'background': [] },{ 'align': [] }],          // dropdown with defaults from theme

    ['blockquote', 'code-block','link'],

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' },'clean'],                         // text direction

];

export default {
    Renderer: (props) => {
        const {data} = props

        return(
            <ReactQuill
                bounds={"#react-page-editable"}
                theme="bubble"
                value={data.content}
                onChange={(v)=>{
                    props.onChange({content:v})
                }}
                placeholder={"Votre Texte Ici..."}
                modules={{
                    toolbar:toolbarOptions
                }}
                readOnly={props.readOnly}
            />
        )

    },
    id: 'text-quill',
    title: 'Texte',
    description: "Un éditeur de texte enrichi avancée.",
    icon: <AlignLeftOutlined />,
    version: 1,
    allowClickInside: true
}
